import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaBancosRecibosIndividualesComponent {
  idPago
  idNomina
  idEmpresa
  idEmpleado
  idMoneda
  importe
  idTipoPago
  idCuentaRetiro
  estatus
  colaborador
  generar = false
}

module.component('nominasNominaBancosRecibosIndividuales', {
  controller: NominasNominaBancosRecibosIndividualesComponent,
  template,
  bindings: {
    idPago: '<',
    idNomina: '<',
    idEmpresa: '<',
    idEmpleado: '<',
    idMoneda: '<',
    importe: '<',
    idTipoPago: '<',
    idCuentaRetiro: '<',
    estatus: '<',
    colaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/recibosindividuales/component.js